<template>
 <div 
 class="faq-item"
 :class="{ active: show }">
  <div 
  class="faq-item-question"
  @click="show = !show"
  >
   <p>{{item_date.question}} </p>
   <div class="img">
    <transition name="fade" mode="in-out">
     <img
     v-if="!show" 
     :src="require('@/landings/LE_NEW/plus.svg')" 
     alt="">
     <img
     v-if="show" 
     :src="require('@/landings/LE_NEW/minus.svg')" 
     alt="">
    </transition>
   </div>
  </div>
  <transition name="fade">
   <div 
   class="faq-item-answer"
   v-if="show">{{item_date.answer}}</div>
  </transition>
  
 </div>
</template>

<script>
export default {
 props: {
  item_date: {
   type: Object,
   default: ()=>{}
  }
 },
 data() {
   return{
     show: false,
   }
 }
}
</script>

<style lang="sass" scoped>
.faq-item        
 border-top: 1px solid
 padding: 0 15px
 background: #fff
 transition: background 1s
 &:first-child
  border-radius: 15px 15px 0 0
 &:last-child
 border-radius: 0 0 15px 15px 
  
 
 &:first-child
   border: none
 .faq-item-question
  // background: #fff
  text-align: left
  font-size: 1em
  font-weight: 700
  height: 60px
  padding-top: 20px
  display: flex
  justify-content: space-between
  .img
   width: 20px
   height: 20px
   display: flex
   justify-content: center
   img
    height: 18px
    width: 18px
 .faq-item-answer
  font-size: 1em
  text-align: left
  // background: #fff
  padding: 15px 0
.active
 background: #F4F4F4

        
</style>